import { defineElement, TemplateElement, html } from '@webtides/element-js';
import style from './products-overview.css';

/**
 * @property {array} selectedCategories
 */
export default class ProductsOverview extends TemplateElement {
    /** @type {NodeListOf<GridSection>} */
    gridSections;

    constructor() {
        super({ styles: [style], shadowRender: true });
    }

    properties() {
        return {
            selectedCategories: [],
        };
    }

    connected() {
        this.gridSections = this.querySelectorAll('mb-grid-section');
    }

    events() {
        return {
            this: {
                'mb-filter-change': (event) => {
                    const selectedCategories = event.detail;
                    for (const gridSection of this.gridSections) {
                        gridSection.style.display =
                            selectedCategories.length === 0 ||
                            selectedCategories.includes(gridSection.getAttribute('name'))
                                ? 'contents'
                                : 'none';
                    }
                },
            },
        };
    }

    template() {
        return html`
            <slot name="filter"></slot>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-40 gap-24">
                <slot></slot>
            </div>
        `;
    }
}

defineElement('mb-products-overview', ProductsOverview);
